module.exports = __webpack_public_path__ + "static/media/fruits_41.fc9720c6.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_41.csv
// module id = 708
// module chunks = 0